var _desc, _defs, _rect, _circle, _circle2, _path, _rect2, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Presente Virei Noiva") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Imagem de fallback para itens do cat\xE1logo de presentes")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f7ece8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#efe6df"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff9f7",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f8efea",
    stopOpacity: 0.92
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 160,
    r: 96,
    fill: "#e9d2c6",
    opacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1050,
    cy: 640,
    r: 120,
    fill: "#e9d2c6",
    opacity: 0.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1020 130c42 0 76 34 76 76s-34 76-76 76-76-34-76-76 34-76 76-76z",
    fill: "#d8b796",
    opacity: 0.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 160,
    width: 660,
    height: 480,
    rx: 34,
    fill: "url(#card)",
    stroke: "#d7b294",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#c8a97e",
    strokeWidth: 12,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450 330c0-48 39-87 87-87 31 0 58 16 74 41 16-25 43-41 74-41 48 0 87 39 87 87 0 99-161 182-161 182S450 429 450 330z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 572,
    textAnchor: "middle",
    fill: "#9b7d65",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 44,
    fontWeight: 600
  }, "\n    Presente Virei Noiva\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogFallback);
export default __webpack_public_path__ + "static/media/catalog-fallback.71894e6d0d77c65d0cf7f34734d26bb4.svg";
export { ForwardRef as ReactComponent };